export default "__VITE_PUBLIC_ASSET__44079974__"